import type { FC } from 'react';
import { useStrongAuthStore } from 'stores/strongAuthStore';
import { OtpAuthenticationModal } from './OtpAuthenticationModal';
import { SsoAndSmsOtpAuthenticationModal } from './SsoAndSmsOtpAuthenticationModal';

export const StrongAuthenticationGate: FC = () => {
  const authRequirement = useStrongAuthStore((state) => state.authRequirement);
  const close = useStrongAuthStore((state) => state.close);
  const resolveStrongAuth = useStrongAuthStore((state) => state.resolveStrongAuth);

  switch (authRequirement) {
    case 'sso_and_sms_otp':
      return <SsoAndSmsOtpAuthenticationModal onClose={close} />;
    case 'otp':
      return <OtpAuthenticationModal onClose={close} onAuthenticated={resolveStrongAuth} />;
    case null:
      return null;
  }
};
